import React from 'react';
import { cn } from '@/lib/utils';

const MAP = {
  draft_patient: { label: 'Waiting on patient', cls: 'bg-[hsl(var(--slate-soft))] text-[hsl(var(--slate-soft-fg))] border-[hsl(214_22%_86%)]' },
  paid: { label: 'Paid', cls: 'bg-[hsl(var(--success))] text-[hsl(var(--success-fg))] border-[hsl(152_52%_84%)]' },
  new: { label: 'New', cls: 'bg-[hsl(var(--info))] text-[hsl(var(--info-fg))] border-[hsl(204_86%_86%)]' },
  in_review: { label: 'In review', cls: 'bg-[hsl(var(--warning))] text-[hsl(var(--warning-fg))] border-[hsl(45_93%_84%)]' },
  awaiting_doctor: { label: 'Awaiting doctor', cls: 'bg-[hsl(var(--warning))] text-[hsl(var(--warning-fg))] border-[hsl(45_93%_84%)]' },
  returned: { label: 'Returned to medical staff', cls: 'bg-[hsl(var(--slate-soft))] text-[hsl(var(--slate-soft-fg))] border-[hsl(214_22%_86%)]' },
  signed: { label: 'Signed', cls: 'bg-[hsl(var(--success))] text-[hsl(var(--success-fg))] border-[hsl(152_52%_84%)]' },
  complete: { label: 'Complete', cls: 'bg-[hsl(var(--success))] text-[hsl(var(--success-fg))] border-[hsl(152_52%_84%)]' },
  // Finished, but with no packet. Slate rather than red: the provider made a
  // legitimate clinical decision, and a red badge would read as an error someone
  // has to fix (LB-LIFE-4).
  declined: { label: 'Not certified', cls: 'bg-[hsl(var(--slate-soft))] text-[hsl(var(--slate-soft-fg))] border-[hsl(214_22%_86%)]' },
  // Closed by staff without a decision (duplicate, created in error). Slate for
  // the same reason as `declined`: it is over, not broken.
  cancelled: { label: 'Cancelled', cls: 'bg-[hsl(var(--slate-soft))] text-[hsl(var(--slate-soft-fg))] border-[hsl(214_22%_86%)]' },
  overdue: { label: 'Overdue', cls: 'bg-[hsl(0_86%_95%)] text-[hsl(0_72%_40%)] border-[hsl(0_84%_88%)]' },
};

export function StatusBadge({ status, overdue, className, 'data-testid': testid }) {
  if (overdue) {
    const m = MAP['overdue'];
    return <span data-testid={testid} className={cn('inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-medium', m.cls, className)}>{m.label}</span>;
  }
  const m = MAP[status] || { label: status || 'Unknown', cls: 'bg-muted text-muted-foreground border-border' };
  return <span data-testid={testid} className={cn('inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-medium', m.cls, className)}>{m.label}</span>;
}
